import React, { Suspense } from 'react';
import BusminApp from 'App';

import Loader from 'components/Loader';

const AppSelector: React.FC = () => {
  return <BusminApp />;
};

export default AppSelector;
